import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select, { components } from "react-select";
import bgimage from '../../../../images/items/items.jpg';
import axios from 'axios';
import { toast } from 'react-toastify';
const EditItem = ({ show, onClose, setItems , onSuccess }) => {    
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [itemCategoryOptions, setItemCategoryOptions] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]); 
    const [scheduleOptions, setScheduleOptions] = useState([]);
    const [selectedSchedule, setSelectedSchedule] = useState([]);
    const [selectedItemCategory, setSelectedItemCategory] = useState(null);
    const [selectedItemQuantity, setSelectedItemQuantity] = useState(null);
    const [selectedItemWeightUnit, setSelectedItemWeightUnit] = useState(null);
    const [selectedItemSizeUnit, setSelectedItemSizeUnit] = useState(null);
    const [file, setFile] = useState(null);
    const imageInputRef = useRef(null);
    const [MeasurementQuantityOptions, setMeasurementQuantityOptions] = useState([]);

    const [propertyTypes, setPropertyTypes] = useState([]);
    const [rawMaterial, setRawMaterial] = useState([{ id: Date.now(), propertyType: null, property: null }]);
    const [isQuantityChecked, setIsQuantityChecked] = useState(false);
    const [isWeightChecked, setIsWeightChecked] = useState(false);
    const [isSizeChecked, setIsSizeChecked] = useState(false);
 
    const [formValues, setFormValues] = useState({
        item_name: '',
        // quantity: '',
        item_weight: '',
        item_size: '',
        cost: '',
        description: '',
        // raw_material: '', // Add raw_material to state
        // measurement_quantity: '',
        catering_corp_quantity: '',       // ✅ added
        catering_corp_unit: '',           // ✅ added
        per_amount: '', // ✅ ADD THIS
    });
    
    const [errors, setErrors] = useState({});
 
useEffect(() => {
    if (!setItems) return;

    setFormValues({
        item_name: setItems.item_name || '', 
        item_weight: parseFloat(setItems.item_weight) || '',
        item_size: parseFloat(setItems.item_size) || '',
        cost: setItems.cost || '',
        description: setItems.description || '', 
        catering_corp_quantity: setItems.catering_corp_quantity || '',
        catering_corp_unit: setItems.catering_corp_unit || '',
        per_amount: setItems.per_amount || '',
    });

    // Catering Corp Unit dropdown
    const matchedUnit = MeasurementQuantityOptions.find(opt => opt.value === setItems.catering_corp_unit);
    setSelectedCateringCorpUnit(matchedUnit || null);

    // Category dropdown
    const foundCategory = itemCategoryOptions.find(group =>
        group.options.some(opt => String(opt.value) === String(setItems.itemsubcategory))
    );
    if (foundCategory) {
        const selectedSubCategory = foundCategory.options.find(opt =>
            String(opt.value) === String(setItems.itemsubcategory)
        );
        setSelectedItemCategory(selectedSubCategory || null);
    }

    // Item image
    if (setItems.item_image) setFile(setItems.item_image);

    // Weight checkbox & unit
    if (parseFloat(setItems.item_weight) > 0) {
        setIsWeightChecked(true);
        const weightUnit = unitOptions.find(u => u.value === setItems.item_unit_id);
        setSelectedItemWeightUnit(weightUnit || null);
    } else {
        setIsWeightChecked(false);
        setSelectedItemWeightUnit(null);
    }

    // Size checkbox & unit
    if (parseFloat(setItems.item_size) > 0) {
        setIsSizeChecked(true);
        const sizeUnit = unitOptions.find(u => u.value === setItems.unit_id);
        setSelectedItemSizeUnit(sizeUnit || null);
    } else {
        setIsSizeChecked(false);
        setSelectedItemSizeUnit(null);
    }

    // Raw Material
    const formattedRawMaterial = setItems.property.map(data => {
        const propertyType = propertyTypes.find(type =>
            type.properties?.some(prop => String(prop.value) === String(data.property_id))
        );
        const property = propertyType?.properties?.find(prop =>
            String(prop.value) === String(data.property_id)
        );
        return {
            id: Date.now() + Math.random(),
            propertyType: propertyType || null,
            property: property || null,
        };
    });
    setRawMaterial(formattedRawMaterial);

}, [setItems, unitOptions, itemCategoryOptions, propertyTypes, MeasurementQuantityOptions]);


    useEffect(() => {
        // Categories
        axios.get(`${baseURL}/grouped-item-categories`)
        .then(response => {
            const categories = response.data.data;
            const formattedOptions = categories.map(category => ({
            label: category.itemcategory_name,
            options: category.subcategories.map(sub => ({
                value: sub.itemsubcategory_id,
                label: sub.itemsubcategory_name,
            })),
            }));
            setItemCategoryOptions(formattedOptions);
        })
        .catch(error => console.error('Error fetching categories:', error));

        // Units
 
          axios.get(`${baseURL}/manageunit/by-category`, {
                params: { unit_category_sno: 1 },
            })
                .then(response => {
                if (response.data.success) {
                    const units = response.data.data;
                    const formattedUnits = units.map(unit => ({
                    value: unit.unit_name,
                    label: unit.unitslug_name,
                    }));
                    setUnitOptions(formattedUnits);
                } else {
                    setUnitOptions([]);
                }
                })
                .catch(error => console.error('Error fetching units by category:', error));

        // Schedules
        axios.get(`${baseURL}/item-schedule/items/active`)
        .then(response => {
            const schedules = response.data.data;
            const formattedSchedules = schedules.map(schedule => ({
            value: schedule.sno,
            label: schedule.itemschedule_name, 
            }));
            setScheduleOptions(formattedSchedules);
        })
        .catch(error => console.error('Error fetching schedules:', error));
        
        fetchUnitsByCategory(1, setMeasurementQuantityOptions);

        fetch(`${baseURL}/property/group/list`)
        .then((res) => res.json())
        .then((data) => {
            const mapped = data.data.map(type => ({
            value: type.sno,
            label: type.propertytype_name,
            properties: type.properties.map(p => ({
                value: p.sno,
                label: p.property_name
            }))
            }));
            setPropertyTypes(mapped);
        });

      }, [baseURL]);

    useEffect(() => {
    if (setItems && scheduleOptions.length > 0) {
      // setItems.schedule is an array of schedules [{sno, itemschedule_name}, ...]
      const selectedSchedules = setItems.schedule
        .map(sch => scheduleOptions.find(opt => opt.value === sch.sno))
        .filter(Boolean); // remove undefined if no match
      setSelectedSchedule(selectedSchedules);
    }
      }, [setItems, scheduleOptions]);

    const fetchUnitsByCategory = async (sno, setOptions) => {
        try {
        const res = await axios.get(`${baseURL}/manageunit/by-category`, {
            params: { unit_category_sno: 1 },
        });
        if (res.data.success) {
            setOptions(res.data.data.map(unit => ({
            value: unit.unit_name,
            label: unit.unitslug_name,
            })));
        }
        } catch (error) {
        console.error(error);
        setOptions([]);
        }
    };
 
    const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'per_amount') {
        // Only digits or empty string allowed
        if (value === '' || /^\d+$/.test(value)) {
        setFormValues(prev => ({
            ...prev,
            [name]: value,
        }));
        }
    } else {
        setFormValues(prev => ({
        ...prev,
        [name]: value,
        }));
    }
    }; 
    
    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333',
        }),
    };

    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
 
    const [imageError, setImageError] = React.useState('');

    const fileHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
        if (file.size > 51200) {  // 50KB limit
        setImageError('Image size must be less than 50 KB');
        setFile(null);  // Clear file preview or selection
        e.target.value = null; // Reset file input so user can re-upload
        } else {
        setImageError('');
        setFile(URL.createObjectURL(file));  // Or your existing way to set preview
        }
    }
    };
 

    const validateForm = () => {
    const formErrors = {};

    if (!selectedItemCategory) {
        formErrors.itemsubcategory = "Item Category / Sub category is required";
    }

    if (!formValues.item_name || typeof formValues.item_name !== 'string' || formValues.item_name.trim() === "") {
        formErrors.item_name = "Item Name is required";
    }

 
    if (isWeightChecked) {
    if (!formValues.item_weight || isNaN(formValues.item_weight) || parseFloat(formValues.item_weight) <= 0) {
        formErrors.item_weight = "Valid Item Weight is required";
    }
    if (!selectedItemWeightUnit) {
        formErrors.units = "Weight Unit is required";
    }
}


 

    if (isSizeChecked) {
        if (!formValues.item_size || String(formValues.item_size).trim() === "") {
            formErrors.item_size = "Item Size is required";
        } else if (isNaN(formValues.item_size) || parseFloat(formValues.item_size) <= 0) {
            formErrors.item_size = "Item Size must be a valid number greater than 0";
        }

        if (!selectedItemSizeUnit) {
            formErrors.item_units = "Size Unit is required";
        }
        }

    
    if (formValues.cost) {
        if (isNaN(formValues.cost) || parseFloat(formValues.cost) < 0) {
            formErrors.cost = "Enter a valid number for Average Production Cost";
        }
    }


    // Validate schedule selection
    if (!selectedSchedule || selectedSchedule.length === 0) {
        formErrors.schedule = "At least one Schedule is required";
    }

    // Image error if any
    if (imageError) {
        formErrors.item_image = imageError;
    }

    if (!formValues.catering_corp_quantity || isNaN(formValues.catering_corp_quantity) || parseFloat(formValues.catering_corp_quantity) <= 0) {
    formErrors.catering_corp_quantity = "Valid Quantity (Per Person) is required";
    }

    if (!formValues.catering_corp_unit) {
    formErrors.catering_corp_unit = "Unit (Per Person) is required";
    }
    
    if (!formValues.per_amount || !/^\d+$/.test(formValues.per_amount) || parseInt(formValues.per_amount, 10) <= 0) {
        formErrors.per_amount = "Valid integer Per Person Amount is required";
    }


    setErrors(formErrors);

    return Object.keys(formErrors).length === 0;
    };

const [selectedCateringCorpUnit, setSelectedCateringCorpUnit] = useState(null);

    const handleUpdateItem = () => {
    if (!validateForm()) {
        return;
    }

    const formData = new FormData();

    // Basic fields
    formData.append('item_name', formValues.item_name); 
    formData.append('item_weight', formValues.item_weight);
    formData.append('item_size', formValues.item_size); 
    formData.append('cost', formValues.cost ? parseFloat(formValues.cost).toFixed(2) : '');

    formData.append('description', formValues.description);

    // Selected dropdowns
    formData.append('itemsubcategory', selectedItemCategory ? selectedItemCategory.value : ''); 
    formData.append('units', selectedItemSizeUnit ? selectedItemSizeUnit.value : '');
    formData.append('item_units', selectedItemWeightUnit ? selectedItemWeightUnit.value : ''); 
    formData.append('catering_corp_quantity', formValues.catering_corp_quantity); 
    formData.append('catering_corp_unit', selectedCateringCorpUnit?.value || ''); 
    formData.append('per_amount', formValues.per_amount ? String(parseInt(formValues.per_amount, 10)) : '');




    // Raw material property_id[]
    rawMaterial.forEach((rm, index) => {
        if (rm.property && rm.property.value) {
            formData.append(`property[${index}][property_id]`, rm.property.value);
        }
    });

    // Multiple selected schedule[] IDs
    selectedSchedule.forEach(sch => {
        formData.append('schedule[]', sch.value);
    });

    // Image file
    if (file && imageInputRef.current?.files?.[0]) {
        const imageFile = imageInputRef.current.files[0];
        formData.append('item_image', imageFile);
    }

    // Submit
    axios.post(`${baseURL}/manage-items/${setItems.sno}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
    .then(response => {
         

        console.log(response.data.message);
        toast.success("Item Updated Successfully!");
                    if (onSuccess) onSuccess();
                    onClose();
        // onClose();
    })
    .catch(error => {
        console.error('Error updating item:', error);
    });
};
 
    const handleCheckboxChange = (e, field) => {
        const checked = e.target.checked;

        if (field === "weight") {
            setIsWeightChecked(checked);
            if (!checked) setFormValues(prev => ({ ...prev, item_weight: '' }));
        } else if (field === "size") {
            setIsSizeChecked(checked);
            if (!checked) setFormValues(prev => ({ ...prev, item_size: '' }));
        }
    };


    const handlePropertyChange = (selectedProperty, index) => {
        const updatedRawMaterial = [...rawMaterial];
        updatedRawMaterial[index].property = selectedProperty;
        setRawMaterial(updatedRawMaterial);
    };
 
    const handlePropertyTypeChange = (selectedType, index) => {
        const updatedRawMaterial = [...rawMaterial];
        updatedRawMaterial[index].propertyType = selectedType;
        updatedRawMaterial[index].property = null; // clear previously selected property
        setRawMaterial(updatedRawMaterial);
    }; 

    const handleDeleteConfig = (id) => {
        setRawMaterial(rawMaterial.filter((r) => r.id !== id));
    };

    const handleAddConfig = () => {
        setRawMaterial([...rawMaterial, { id: Date.now(), propertyType: null, property: null }]);
    };

    const handleSelectChange = (selected, name) => {
        setFormValues(prev => ({ ...prev, [name]: selected?.value || '' }));
    };

    return (
        <Modal show={show} onHide={onClose} size="xl">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Item</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* item category & name */}
                    <div className="row">
                        {/* item category */}
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Item Category / Sub category<span className="required">*</span></label>
                            <Select
                                placeholder="Select Item Category"
                                options={itemCategoryOptions}
                                components={{ Group }}
                                styles={customStyles}
                                value={selectedItemCategory}
                                onChange={setSelectedItemCategory}
                            />
                            {errors.itemsubcategory && <div className="text-danger">{errors.itemsubcategory}</div>}
                        </div>

                        {/* item name */}
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Item Name<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Item Name"
                                name="item_name"
                                value={formValues.item_name}
                                onChange={handleInputChange}
                            />
                            {errors.item_name && <div className="text-danger">{errors.item_name}</div>}
                        </div>
                    
                        <div className="col-lg-3 mb-4">
                            <label className="text-black font-w500 fs-7">
                            Quantity(Per Person) <span className="required">*</span>
                            </label>
                             <input
                                type="text"
                                name="catering_corp_quantity"
                                className="form-control"
                                placeholder="Enter for per person"
                                value={formValues.catering_corp_quantity}
                                onChange={handleInputChange}
                                />
                                {errors.catering_corp_quantity && (
                                <span className="text-danger">{errors.catering_corp_quantity}</span>
                                )} 
                        </div> 
                        <div className="col-lg-3 mb-4">
                            <label className="text-black font-w500 fs-7">
                            Unit(Per Person) <span className="required">*</span>
                            </label>
                                <Select
                                placeholder="Select Unit"
                                options={MeasurementQuantityOptions}
                                value={selectedCateringCorpUnit}
                                onChange={selected => {
                                    setSelectedCateringCorpUnit(selected);
                                    setFormValues(prev => ({
                                    ...prev,
                                    catering_corp_unit: selected?.value || ''
                                    }));
                                }}
                                /> 
                            {errors.catering_corp_unit && <span className="text-danger">{errors.catering_corp_unit}</span>}
                        </div> 
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">
                                Per Person Amount<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Per Person Amount"
                                name="per_amount"
                                value={formValues.per_amount}
                                onChange={handleInputChange}
                            />
                            {errors.per_amount && <div className="text-danger">{errors.per_amount}</div>}
                        </div>

                   
                    </div> 

                    <div className="row">
                        {/* Item Weight Section */}
                        <div className="col-lg-6">
                            <div className="row">
                            <div className="col-lg-6">
                                <div className="form-check custom-checkbox mb-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    id="customCheckBoxWeight"
                                    checked={isWeightChecked}
                                    onChange={(e) => handleCheckboxChange(e, "weight")}
                                />
                                <label className="text-black font-w500 fs-7" htmlFor="customCheckBoxWeight">
                                    Item Weight {isWeightChecked && <span className="required">*</span>}
                                </label>
                                </div>

                                {isWeightChecked && (
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Item Weight"
                                    name="item_weight"
                                    value={formValues.item_weight}
                                    onChange={handleInputChange}
                                    readOnly={!isWeightChecked}
                                />
                                )}
                                {errors.item_weight && <div className="text-danger">{errors.item_weight}</div>}
                            </div>

                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">
                                Weight Unit {isWeightChecked && <span className="required">*</span>}
                                </label>
                                <Select
                                placeholder="Select Weight Unit"
                                value={selectedItemWeightUnit}
                                onChange={setSelectedItemWeightUnit}
                                options={unitOptions}
                                isDisabled={!isWeightChecked}
                                /> 
                                {errors.item_weight_unit && <div className="text-danger">{errors.item_weight_unit}</div>}
                            </div>
                            </div>
                        </div>

                        {/* Item Size Section */}
                        <div className="col-lg-6">
                            <div className="row">
                            <div className="col-lg-6">
                                <div className="form-check custom-checkbox mb-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    id="customCheckBoxSize"
                                    checked={isSizeChecked}
                                    onChange={(e) => handleCheckboxChange(e, "size")}
                                />
                                <label className="text-black font-w500 fs-7" htmlFor="customCheckBoxSize">
                                    Item Size {isSizeChecked && <span className="required">*</span>}
                                </label>
                                </div>

                                {isSizeChecked && (
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Item Size"
                                    name="item_size"
                                    value={formValues.item_size}
                                    onChange={handleInputChange} 
                                />
                                )}
                                {errors.item_size && <div className="text-danger">{errors.item_size}</div>}
                            </div>

                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">
                                Size Unit {isSizeChecked && <span className="required">*</span>}
                                </label>
                                <Select
                                placeholder="Select Size Unit"
                                value={selectedItemSizeUnit}
                                onChange={setSelectedItemSizeUnit}
                                options={unitOptions}
                                isDisabled={!isSizeChecked}
                                /> 
                                {errors.item_size_unit && <div className="text-danger">{errors.item_size_unit}</div>}
                            </div>
                            </div>
                        </div>

                        {/* Average Production Cost */}
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">
                            Average Production Cost <span className="required">*</span>
                            </label>
                            <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Average Production Cost"
                            name="cost"
                            value={formValues.cost}
                            onChange={handleInputChange}
                            />
                            {errors.cost && <div className="text-danger">{errors.cost}</div>}
                        </div>

                        {/* Item Schedule */}
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">
                            Item Schedule <span className="required">*</span>
                            </label>
                            <Select
                            placeholder="Select Schedule"
                            value={selectedSchedule}
                            onChange={setSelectedSchedule}
                            options={scheduleOptions}
                            isMulti
                            />
                            {errors.schedule && <div className="text-danger">{errors.schedule}</div>}
                        </div>

                        {/* Description */}
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                            className="form-control"
                            placeholder="Description"
                            name="description"
                            value={formValues.description}
                            onChange={handleInputChange}
                            />
                        </div>

                        {/* Item Image */}
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Item Image</label>
                            <div className="avatar-upload d-flex align-items-center">
                            <div className="change position-relative px-0">
                                <div
                                className="avatar-preview h-100px w-100px border"
                                style={{ borderRadius: '10px' }}
                                >
                                <img
                                    src={file || bgimage}
                                    alt="Item"
                                    className="p-1 h-100px w-100px"
                                />
                                </div>
                                <div className="change-btn">
                                <input
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={fileHandler}
                                    ref={imageInputRef}
                                />
                                <div className="mt-2 d-flex justify-content-center gap-3">
                                    <Button
                                    className="btn-xs mb-2"
                                    variant="success"
                                    onClick={() => imageInputRef.current.click()}
                                    >
                                    <i className="fa fa-upload color-success fs-4" />
                                    </Button>
                                    <Button
                                    className="btn-xs mb-2"
                                    variant="danger"
                                    onClick={RemoveImage}
                                    >
                                    <i className="fa fa-close color-danger fs-4" />
                                    </Button>
                                </div>
                                {imageError && (
                                    <span style={{ color: 'red', fontSize: '12px' }}>{imageError}</span>
                                )}
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
 
                    {/* Raw Materials Section */}
                    <div className='row'>
                        <div className='scroll-y mh-350px py-2'>
                        <div className="col-lg-12">
                            <div className="mb-0">
                            {rawMaterial.map((config, index) => (
                                <div key={config.id} data-repeater-item>
                                    <div className="row">
                                        <div className="col-lg-4 mb-4">
                                            <label className="text-black font-w500 fs-7">
                                                Item Property Type<span className="required">*</span>
                                            </label>
                                            <Select
                                                placeholder="Select Item Prope..."
                                                value={config.propertyType}
                                                options={propertyTypes}
                                                onChange={(selected) => handlePropertyTypeChange(selected, index)}
                                                styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                            />
                                            {errors[`propertyType_${index}`] && (
                                                <div className="text-danger small">{errors[`propertyType_${index}`]}</div>
                                            )}
                                        </div>

                                        <div className="col-lg-4 mb-4">
                                            <label className="text-black font-w500 fs-7">
                                                Item Property<span className="required">*</span>
                                            </label>
                                            <Select
                                                placeholder="Select Item Property"
                                                value={config.property}
                                                options={config.propertyType ? config.propertyType.properties : []}
                                                onChange={(selected) => handlePropertyChange(selected, index)}
                                                styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                isDisabled={!config.propertyType} // disable until a type is selected
                                            />
                                            {errors[`property_${index}`] && (
                                                <div className="text-danger small">{errors[`property_${index}`]}</div>
                                            )}
                                        </div>

                                        <div className="col-lg-1 mb-1 px-1 py-1">
                                            {rawMaterial.length > 1 && (
                                                <button
                                                type="button"
                                                className="btn btn-danger mt-4 px-2 py-2"
                                                onClick={() => handleDeleteConfig(config.id)}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete"
                                                >
                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            </div>
                        </div>
                        </div>
                        <div className="mb-1 mt-1">
                        <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={handleAddConfig}
                        >
                            <span><i className="fa-solid fa-plus fs-6"></i></span>
                            <span className='ms-2 fs-7'>Add More</span>
                        </button>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4"> 
                        <Button className="btn btn-sm btn-primary" onClick={handleUpdateItem}>Update Item<i className="fas fa-angle-double-right ms-2"></i></Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditItem;
